/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class MobileViewEvents {
}
MobileViewEvents.MOBILE_VIEW_EVENT = 'dell.sirius.platform.mobile-view.state-changed';
MobileViewEvents.NATIVE_MOBILE_MENU_VISIBLE_EVENT = 'dell.sirius.platform.mobile-view.mobile-menu.visibility-changed';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9iaWxlLXZpZXctZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9tb2JpbGUtdmlldy9ldmVudHMvbW9iaWxlLXZpZXctZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGdCQUFnQjs7QUFDRixrQ0FBaUIsR0FBRyxnREFBZ0QsQ0FBQztBQUNyRSxpREFBZ0MsR0FBRyxpRUFBaUUsQ0FBQyJ9